import {Component, OnInit} from '@angular/core';
import {SubscriberComponent} from './subscriber.component';
import {Organization} from '../_models/organization';
import {PickupLocation} from '../_models/pickup-location';
import {User} from '../_models/user';
import {UserService} from '../_services/user.service';
import {OrganizationService} from '../_services/organization.service';
import {PickupLocationService} from '../_services/pickup-location.service';
import {AuthenticationService} from '../_services/authentication.service';
import {Membership} from '../_models/membership';
import {MembershipService} from '../_services/membership.service';
import {DonationProgram} from '../_models/donation-program';
import {DonationProgramStatus} from '../_constants/donation-program-status';

@Component({
    template: ''
})
export abstract class BaseManagerComponent extends SubscriberComponent implements OnInit {
    organization: Organization;
    activeDonationPrograms: DonationProgram[] = [];
    pickupLocation: PickupLocation;
    currentUser: User;
    activeMember: Membership;

    abstract init();

    protected constructor(
        public authenticationService: AuthenticationService,
        public organizationService: OrganizationService,
        public pickupLocationService: PickupLocationService,
        public userService: UserService,
        public membershipService: MembershipService
    ) {
        super();
    }

    ngOnInit(): void {
        this.pickupLocation = !!this.pickupLocationService.currentValue
            ? new PickupLocation(this.pickupLocationService.currentValue)
            : null;
        this.organization = !!this.organizationService.currentValue ? new Organization(this.organizationService.currentValue) : null;
        this.currentUser = !!this.userService.currentValue ? new User(this.userService.currentValue) : null;

        this.subscribe(this.userService.current.subscribe((user: User) => {
            const prev = this.currentUser;
            this.currentUser = !!user ? new User(user) : null;
            if (!!this.currentUser && (!prev || prev.id !== this.currentUser.id)) {
                this.checkInit();
            }
        }));

        this.subscribe(this.organizationService.current.subscribe((o: Organization) => {
            const prev = this.organization;
            this.organization = !!o ? new Organization(o) : null;

            if (!!this.organization) {
                this.activeDonationPrograms = this.organization.donationPrograms.filter(d => d.status === DonationProgramStatus.ACTIVE);
            }

            if (!!this.organization && (!prev || prev.id !== this.organization.id)) {
                this.checkInit();
            }
        }));

        this.subscribe(this.pickupLocationService.current.subscribe(p => {
            const prev = this.pickupLocation;
            this.pickupLocation = p;
            if (!!this.pickupLocation) {
                localStorage.setItem('ACTIVE_PICKUP_LOCATION', this.pickupLocation.id.toString(10));
            }
            if (!!this.pickupLocation && (!prev || prev.id !== this.pickupLocation.id)) {
                this.checkInit();
            }
        }));

        this.subscribe(this.membershipService.current.subscribe(m => this.activeMember = !!m ? new Membership(m) : null));

        this.checkInit();
    }

    checkInit() {
        if (!!this.currentUser
            && !!this.organization
            && !!this.pickupLocation) {
            this.init();
        }
    }
}
